import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";
export default class CrawlDomesticIndicatorService extends BaseService {
    crawlDomesticIndicator = (data) => {
        return this.axios.post(API_ENDPOINTS.CRAWL_DOMESTIC_INDICATOR, data);
    }
    getCrawlDomesticIndicator = () => {
        return this.axios.get(API_ENDPOINTS.GET_CRAWL_DOMESTIC_INDICATOR);
    }
    deleteInformationStore = () => {
        return this.axios.get(API_ENDPOINTS.DELETE_INFORMATION_STORES_DOMESTIC_INDICATOR);
    }
    getInformationStore = () => {
        return this.axios.get(API_ENDPOINTS.GET_EXCEL_DOMESTIC_INDICATOR);
    }
    updateFormula = (data) => {
        return this.axios.post(API_ENDPOINTS.UPDATE_FORMULA_DOMESTIC_INDICATOR, data);
    }
}